import { VApp } from 'vuetify/lib/components/VApp';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{style:({ background: _vm.$vuetify.theme.themes.light.background })},[_c('SkipLink'),_c('AppBar'),_c('Content'),_c('Footer'),_c('BackToTop'),_c('UnsubscribeTemplate',{ref:"unsubscribeComponent",attrs:{"unsubscribeEmail":_vm.unsubscribeEmail,"unsubscribeType":_vm.unsubscribeType,"notificationSettings":_vm.notificationSettings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }